const MenuApi =  [
    {
        id: "1",
        name: "Home",
        linkHref: "home",
        icon: "las la-home",
    },
    {
        id: "2",
        name: "About",
        linkHref: "about",
        icon: "las la-user",
    },
    {
        id: "3",
        name: "Resume",
        linkHref: "resume",
        icon: "las la-briefcase",
    },
    // {
    //     id: "4",
    //     name: "Services",
    //     linkHref: "services",
    //     icon: "las la-stream",
    // },
    // {
    //     id: "5",
    //     name: "Skills",
    //     linkHref: "skills",
    //     icon: "las la-shapes",
    // },
    {
        id: "6",
        name: "Portfolios",
        linkHref: "portfolio",
        icon: "las la-grip-vertical",
    },
    // {
    //     id: "7",
    //     name: "Contact",
    //     linkHref: "contact",
    //     icon: "las la-envelope",
    // },
]
export default MenuApi;
